import { ASC } from 'framework/list';
import useLeadService, { READ_LEAD_NOTIFICATION_FE } from 'domain/sales/lead/shared/leadService';
import { useDateService, useDateTimeService, useAsyncValue } from 'framework/utils';
import useAuthenticatedUserService from 'infrastructure/security/authentication/authenticatedUserService';
import { useAuthorization } from 'framework/authorization';
import NewLeadsNotificationButton from './NewLeadsNotificationButton';
import StaleLeadsNotificationButton from './StaleLeadsNotificationButton';
import { NotificationItemProps } from 'infrastructure/notification/types';
import { NOTIFICATIONS_TYPES } from 'infrastructure/notification/constants';

const useLeadsNotification = (): NotificationItemProps[] => {
  const { search } = useLeadService() as any;
  const { getCurrentDateTimeInUtc } = useDateService();
  const { formatDateForAPI } = useDateTimeService();
  const { getUserAlias } = useAuthenticatedUserService();
  const currentUserAlias = useAsyncValue(async () => getUserAlias());
  const { isGranted } = useAuthorization();

  if (!currentUserAlias || !isGranted(READ_LEAD_NOTIFICATION_FE)) return [];

  const currentUtcDate = getCurrentDateTimeInUtc();
  const staleDate = currentUtcDate.subtract(21, 'days');
  const formattedStaleDate = formatDateForAPI(staleDate, 'end');

  const filterState = {
    status: { in: ['NEW', 'ASSIGNED', 'OPEN'] },
    updatedAt: { le: formattedStaleDate },
    'owner.alias': { in: [currentUserAlias] },
  };

  const filterNewState = {
    status: { in: ['NEW'] },
  };

  return [
    {
      type: NOTIFICATIONS_TYPES.LEAD_STALE,
      isVisible: (response: any) => !!response?.result?.length,
      getCount: (response: any) => response?.totalElements ?? 0,
      autoUpdate: true,
      loadData: () => search({ filter: filterState, sort: { updatedAt: ASC }, pageSize: 1 }),
      component: (response: any) => <StaleLeadsNotificationButton state={filterState} response={response} />,
    },
    {
      type: NOTIFICATIONS_TYPES.LEAD_NEW,
      isVisible: (response: any) => !!response?.result?.length,
      getCount: (response: any) => response?.totalElements ?? 0,
      autoUpdate: true,
      loadData: () =>
        search({
          filter: filterNewState,
          sort: { updatedAt: ASC },
          pageSize: 1,
        }),
      component: (response: any) => <NewLeadsNotificationButton state={filterNewState} response={response} />,
    },
  ];
};

export default useLeadsNotification;
